import React from 'react';
import RankingBase from '../components/base/ranking-base';

const ChampionshipRulesRanking = () => {
  return <RankingBase sportType="general" />;
};

export default ChampionshipRulesRanking;
